import * as THREE from 'three';

type DustPuff = {
  mesh: THREE.Mesh;
  vel: THREE.Vector3;
  life: number;
  maxLife: number;
};

const LIFE = 0.32;

/** Ground dust puffs when the player sprints or runs on foot. */
export class FpsFootstepDust {
  private readonly puffs: DustPuff[] = [];
  private readonly geo = new THREE.SphereGeometry(0.04, 4, 4);
  private readonly colors = [0xb8a88a, 0xc4b498, 0x8a7a6a, 0xd0c4ac];

  constructor(private readonly scene: THREE.Scene) {}

  spawn(x: number, y: number, z: number): void {
    const count = 3 + Math.floor(Math.random() * 3);
    for (let i = 0; i < count; i++) {
      const mat = new THREE.MeshBasicMaterial({
        color: this.colors[i % this.colors.length]!,
        transparent: true,
        opacity: 0.58,
        depthWrite: false,
      });
      const mesh = new THREE.Mesh(this.geo, mat);
      mesh.position.set(
        x + (Math.random() - 0.5) * 0.24,
        y + 0.02 + Math.random() * 0.05,
        z + (Math.random() - 0.5) * 0.24,
      );
      mesh.scale.setScalar(0.65 + Math.random() * 0.45);
      this.scene.add(mesh);

      const angle = Math.random() * Math.PI * 2;
      const spread = 0.35 + Math.random() * 0.55;
      const vel = new THREE.Vector3(
        Math.cos(angle) * spread,
        0.22 + Math.random() * 0.42,
        Math.sin(angle) * spread,
      );

      this.puffs.push({ mesh, vel, life: 0, maxLife: LIFE * (0.85 + Math.random() * 0.3) });
    }
  }

  update(dt: number): void {
    for (let i = this.puffs.length - 1; i >= 0; i--) {
      const d = this.puffs[i]!;
      d.life += dt;
      d.mesh.position.addScaledVector(d.vel, dt);
      d.vel.y -= dt * 2.6;
      d.vel.multiplyScalar(1 - dt * 2.0);
      const t = d.life / d.maxLife;
      const mat = d.mesh.material as THREE.MeshBasicMaterial;
      mat.opacity = Math.max(0, 0.58 * (1 - t * t));
      d.mesh.scale.setScalar((0.65 + t * 1.05) * (1 - t * 0.25));
      if (d.life >= d.maxLife) {
        this.scene.remove(d.mesh);
        mat.dispose();
        this.puffs.splice(i, 1);
      }
    }
  }

  dispose(): void {
    for (const d of this.puffs) {
      this.scene.remove(d.mesh);
      (d.mesh.material as THREE.Material).dispose();
    }
    this.puffs.length = 0;
    this.geo.dispose();
  }
}
